import moment from "moment";
import { getFieldValue } from "../../utils/quotationUtils";
import { createRandomMappingID } from "../../utils/fieldsSettingsUtils";
// import FieldTableData from "../../components/DataStudio/FieldsData/FieldTableData";
import { FIELDS_SUB_DIVISION_MAP, DATA_SOURCES } from "../../constants/fields";
import getEditorHTML from "../../components/CustomRevvEditor/getEditorHtml";
import { convertRawToDraft } from "../../utils/components";

const EXCLUDE_FOR_DEFAULT = ["TABLE", "IMAGE"];

export const checkFieldAllowedForDataMapping = field => {
  if (EXCLUDE_FOR_DEFAULT.includes(field.type)) return false;
  if (field.type === "CLAUSE") {
    const { meta: { subtype: subType } = {} } = field;
    if (subType === "free_text") return true;

    return false;
  }
  return true;
};

export const formatFormField = field => {
  const fieldDetails = {
    ...field,
  };
  if (
    field &&
    field.meta &&
    field.meta.default &&
    checkFieldAllowedForDataMapping(field)
  ) {
    fieldDetails.defaultValue = getFieldValue({
      ...field,
      value: field.meta.default,
    });
  } else {
    fieldDetails.defaultValue = "";
  }
  return fieldDetails;
};

export const formatMetaField = field => {
  const fieldDetails = {
    ...field,
  };
  if (field && field.field_meta && field.field_meta.default) {
    if (field.field_type === "TEXT" || field.field_type === "NUMBER") {
      fieldDetails.defaultValue = field.field_meta.default;
    } else if (field.field_type === "DATE") {
      fieldDetails.defaultValue = moment(field.field_meta.default).format(
        "DD-MM-YYYY",
      );
    } else {
      fieldDetails.defaultValue = Array.isArray(field.field_meta.default)
        ? field.field_meta.default.join(", ")
        : field.field_meta.default;
    }
  } else {
    fieldDetails.defaultValue = "";
  }
  fieldDetails.type = fieldDetails.field_type;
  fieldDetails.parent_field = "META_FIELD";
  fieldDetails.meta = fieldDetails.field_meta;
  delete fieldDetails.field_type;
  delete fieldDetails.field_meta;
  return fieldDetails;
};

export const formatFormFields = fieldsList => {
  let fieldList = [];
  const fieldDefs = {};
  const fieldIDsList = [];
  const fieldIDsWithInternalField = [];
  const tableIdsList = [];
  const tableIDsWithInternalField = [];
  if (Array.isArray(fieldsList)) {
    fieldList = fieldsList.filter(field =>
      checkFieldAllowedForDataMapping(field),
    );
    fieldList.forEach(field => {
      if (field.type !== "SIGNATURE" && !field.id.startsWith("METAG")) {
        const formattedField = formatFormField(field);
        field.defaultValue = formattedField.defaultValue;
        field.parent_field = "FORM_FIELD";
        fieldDefs[field.id] = { ...formattedField, usedInCurrFieldMap: false };
        if (field.type !== "TABLE_API") {
          fieldIDsList.push(field.id);
        }

        // check for internal fields
        if (field.type in FIELDS_SUB_DIVISION_MAP) {
          FIELDS_SUB_DIVISION_MAP[field.type].forEach(sub => {
            const subFieldId = `${field.id}-${sub}`;
            fieldDefs[subFieldId] = {
              ...field,
              label: `${field.label}.${sub}`,
              sub_field: sub,
              usedInCurrFieldMap: false,
            };
            fieldIDsWithInternalField.push(subFieldId);
          });
        } else if (field.type === "TABLE_API") {
          tableIdsList.push(field.id);
          Object.entries(field.meta.table.table_schema.label_map).forEach(
            item => {
              const subFieldId = `${field.id}-${item[1].text}`;
              fieldDefs[subFieldId] = {
                ...field,
                label: `${field.label}`,
                sub_field: item[1].text,
                usedInCurrFieldMap: false,
              };
              tableIDsWithInternalField.push(subFieldId);
            },
          );
        } else {
          fieldIDsWithInternalField.push(field.id);
        }
      }
      if (field.type === "SIGNATURE") {
        const formattedField = formatFormField(field);
        field.defaultValue = formattedField.defaultValue;
      }
    });
  }
  return {
    fieldList,
    fieldDefs,
    fieldIDsList,
    fieldIDsWithInternalField,
    tableIdsList,
    tableIDsWithInternalField,
  };
};
export const formatSinatoriesFields = fieldsList => {
  let signerList = [];
  const signerDefs = {};
  const signerIDsList = [];
  const signerIDsWithInternalField = [];
  if (Array.isArray(fieldsList)) {
    signerList = fieldsList.filter(field =>
      checkFieldAllowedForDataMapping(field),
    );
    signerList.forEach(field => {
      const formattedField = formatFormField(field);
      field.defaultValue = formattedField.defaultValue;
      signerDefs[field.id] = { ...formattedField, usedInCurrFieldMap: false };
      signerIDsList.push(field.id);
      // check for internal fields
      if (field.type in FIELDS_SUB_DIVISION_MAP) {
        FIELDS_SUB_DIVISION_MAP[field.type].forEach(sub => {
          const subFieldId = `${field.id}-${sub}`;
          signerDefs[subFieldId] = {
            ...field,
            label: `${field.label}`,
            sub_field: sub,
            usedInCurrFieldMap: false,
          };
          signerIDsWithInternalField.push(subFieldId);
        });
      } else {
        signerIDsWithInternalField.push(field.id);
      }
    });
  }
  return { signerDefs, signerIDsList, signerIDsWithInternalField };
};

export const formatMetaFields = metaFieldGroup => {
  const metaFieldsList = [];
  const metaFieldDefs = {};
  const metaFieldIDsList = [];
  const metaFieldIDsWithInternalField = [];
  if (metaFieldGroup) {
    const metaFieldList = metaFieldGroup.meta.fields;
    Object.keys(metaFieldList).forEach(metaField => {
      const formattedField = formatMetaField(metaFieldList[metaField]);
      metaFieldList[metaField].defaultValue = formattedField.defaultValue;
      metaFieldDefs[`${metaFieldGroup.id}-${metaField}`] = {
        ...formattedField,
        // type: "META_FIELD",
        id: `${metaFieldGroup.id}-${metaField}`,
        field_name: metaField,
        label: metaField,
        source: "form",
        usedInCurrFieldMap: false,
      };
      metaFieldsList.push({
        ...formattedField,
        // type: "META_FIELD",
        id: `${metaFieldGroup.id}-${metaField}`,
        field_name: metaField,
        label: metaField,
        source: "form",
        usedInCurrFieldMap: false,
      });
      metaFieldIDsList.push(`${metaFieldGroup.id}-${metaField}`);
      metaFieldIDsWithInternalField.push(`${metaFieldGroup.id}-${metaField}`);
    });
  }
  return {
    metaFieldsList,
    metaFieldDefs,
    metaFieldIDsList,
    metaFieldIDsWithInternalField,
  };
};

export const formatFieldData = (fieldData, fieldDefs, tableIdsList) => {
  if (Array.isArray(fieldData)) {
    return fieldData.map(field => {
      const formattedData = {};
      Object.keys(field).forEach(fieldId => {
        if (Array.isArray(tableIdsList) && tableIdsList.includes(fieldId)) {
          formattedData[fieldId] = "Table";
        } else {
          const fieldDef = fieldDefs[fieldId];
          let fieldValue = getFieldValue({
            ...fieldDef,
            value: field[fieldId],
          });
          if (
            fieldDef &&
            fieldDef.type === "CLAUSE" &&
            fieldDef.meta &&
            fieldDef.meta.subtype === "free_text"
          ) {
            if (
              typeof fieldValue === "string" &&
              fieldValue.startsWith('{"blocks":')
            ) {
              try {
                const contentState = convertRawToDraft(JSON.parse(fieldValue));
                const editorHtml = getEditorHTML(contentState);
                fieldValue = editorHtml;
              } catch (err) {
                fieldValue = "";
                console.error(
                  "fieldsSettingMethod => formatFieldData => Error ",
                  err,
                );
              }
            } else if (typeof fieldValue === "object") {
              try {
                const contentState = convertRawToDraft(fieldValue);
                const editorHtml = getEditorHTML(contentState);
                fieldValue = editorHtml;
              } catch (err) {
                fieldValue = "";
                console.error(
                  "fieldsSettingMethod => formatFieldData => Error ",
                  err,
                );
              }
            }
          }
          formattedData[fieldId] = fieldValue;
        }
      });
      return {
        ...formattedData,
      };
    });
  }
  return fieldData;
};

export const getColumnDefs = (
  fieldData,
  fieldsList,
  primaryFieldId,
  tableIdsList,
) => {
  if (
    Array.isArray(fieldData) &&
    fieldData.length > 0 &&
    Array.isArray(fieldsList) &&
    fieldsList.length > 0
  ) {
    const firstRow = fieldData[0];
    const columns = [];
    Object.keys(firstRow).forEach((fieldID, index) => {
      const field = fieldsList.find(fld => fld.id === fieldID);
      if (field) {
        const columnDef = {
          editable: false,
          hidden: undefined,
          hide: false,
          minWidth: 80,
          props: { length: 200 },
          required: true,
          resizable: false,
          sortable: true,
          standard: true,
          suppressMenu: true,
          type: "text",
          visible: true,
          // width: 100,
          field: fieldID,
          name: fieldID,
          headerName: field.label,
          position: index + 1,
          enableRowGroup: true,
          suppressSizeToFit: true,
          // wrapText: true,
          autoHeight: true,
          cellStyle: { "white-space": "normal", "line-height": 1.5 },
          menuTabs: ["generalMenuTab", "gibberishMenuTab"],
        };
        if (field.id.startsWith("METAG")) {
          columnDef.headerName = `${field.label} (M)`;
          columnDef.headerTooltip = "Metafield";
          columnDef.tooltipComponentParams = { color: "#fff" };
        }
        if (index === 0) {
          // columnDef.headerCheckboxSelection = "true";
          // columnDef.headerCheckboxSelectionFilteredOnly = "true";
          columnDef.checkboxSelection = "true";
        }
        if (Array.isArray(tableIdsList) && tableIdsList.includes(fieldID)) {
          // columnDef.cellRenderer = "FieldTableData";
          columnDef.cellRenderer = "FieldDataDetails";
          columnDef.type = "Table";
        }
        if (
          field.type === "CLAUSE" &&
          field.meta &&
          field.meta.subtype === "free_text"
        ) {
          columnDef.cellRenderer = function (params) {
            return params.value;
          };
          columnDef.resizable = true;
        }
        if (primaryFieldId && fieldID === primaryFieldId) {
          columnDef.isPrimaryKey = true;
          columns.splice(0, 0, columnDef);
        } else {
          columns.push(columnDef);
        }
      }
    });

    columns[0].checkboxSelection = true;
    return columns;
  }
  return [];
};

export const formatFieldsMapping = fieldsMapping => {
  const objectFieldMapping = {};
  if (Array.isArray(fieldsMapping)) {
    fieldsMapping.forEach(fieldMapping => {
      const {
        form_field_id: formFieldId,
        signer_id: signerId,
        meta_group_id: metaGroupId,
        object_name: objectName,
        schema,
        id,
        source,
      } = fieldMapping;
      const fieldId = formFieldId || signerId || metaGroupId;
      if (objectName in objectFieldMapping) {
        objectFieldMapping[objectName][fieldId] = {
          ...schema,
          id,
        };
      } else if (objectName === "" && source === "CSV") {
        if (objectFieldMapping[source] && objectFieldMapping[source][fieldId]) {
          objectFieldMapping[source][fieldId] = {
            ...schema,
            id,
          };
        } else {
          objectFieldMapping[source] = {
            ...objectFieldMapping[source],
            [fieldId]: {
              ...schema,
              id,
            },
          };
        }
      } else {
        objectFieldMapping[objectName] = {
          [fieldId]: {
            ...schema,
            id,
          },
        };
      }
    });
  }
  return objectFieldMapping;
};

export const formatCRMObjects = crmObjects =>
  crmObjects.map(obj => ({
    ...obj,
    sublabel: "",
    value: obj.name,
  }));

export const getUnusedRevvFields = (
  revvFieldIDsWithInternalField,
  objectFieldsMapping,
) => {
  // check if the field list is empty or not
  if (!Array.isArray(revvFieldIDsWithInternalField)) return [];

  // create a list of unused fields
  const usedRevvFieldIDs = objectFieldsMapping.map(mapping =>
    mapping.revvSubField
      ? `${mapping.revvFieldID}-${mapping.revvSubField}`
      : mapping.revvFieldID,
  );
  // filter out those fields, which are already used in fields mapping
  const unusedRevvFieldIDs = revvFieldIDsWithInternalField.filter(
    fieldId => !usedRevvFieldIDs.includes(fieldId),
  );

  return unusedRevvFieldIDs;
};

export const getSourceToRevvFieldsMapping = (
  revvFieldsMapping,
  revvFieldDefs,
) => {
  const fieldMappingList = [];
  if (!revvFieldsMapping || Object.keys(revvFieldsMapping).length === 0)
    return fieldMappingList;
  Object.keys(revvFieldsMapping).forEach(revvFieldID => {
    const mapping = revvFieldsMapping[revvFieldID];
    const {
      meta: {
        internal_fields: internalFields,
        is_primary_key: isPrimaryKey = false,
      } = {},
      mapping: fieldMapping,
      id,
    } = mapping;

    const field = revvFieldID in revvFieldDefs && revvFieldDefs[revvFieldID];
    if (field) {
      let revvSubFields = [];
      if (
        field.type in FIELDS_SUB_DIVISION_MAP &&
        Array.isArray(internalFields)
      ) {
        revvSubFields = internalFields;
      } else if (field.type === "TABLE_API") {
        const {
          meta: {
            table: { table_schema: tableSchema, column_order: columnOrder },
          },
        } = field;
        revvSubFields = columnOrder.map(
          colId => tableSchema.label_map[colId].text,
        );
      }

      if (revvSubFields.length === 0) {
        const mappingID = createRandomMappingID();
        fieldMappingList.push({
          mapping: fieldMapping.length > 0 ? fieldMapping[0] : [],
          revvSubField: null,
          revvFieldID,
          mappingID,
          id,
          isPrimaryKey,
        });
      } else {
        revvSubFields.forEach(subField => {
          const internalFieldMapping = fieldMapping.find(
            map => map.internal_field === subField,
          );
          if (internalFieldMapping) {
            const mappingID = createRandomMappingID();
            fieldMappingList.push({
              mapping: internalFieldMapping,
              revvSubField: subField,
              revvFieldID,
              mappingID,
              id,
              isPrimaryKey,
            });
          }
        });
      }
    }
  });
  return fieldMappingList;
};

export const formatObjectSchema = objSchema => {
  if (Array.isArray(objSchema)) {
    const fieldList = [];
    const filteredObj = { MultiReference: [] };
    objSchema.forEach(field => {
      if (
        field.field_type !== "reference" &&
        field.field_type !== "multi_reference"
      ) {
        fieldList.push(field);
      } else if (Array.isArray(field.referObj)) {
        const filteredFieldList = [];
        field.referObj.forEach(subField => {
          if (
            field.field_type === "reference" &&
            field.relationship_name === "" &&
            Array.isArray(field.reference_to) &&
            field.reference_to.length > 0
          ) {
            const subFieldDef = {
              ...subField,
              name: `${field.reference_to[0]}.${subField.name}`,
              label: `${field.reference_to[0]}.${subField.label}`,
              parent_field_type: field.field_type,
            };
            fieldList.push(subFieldDef);
            filteredFieldList.push(subFieldDef);
          } else {
            const subFieldDef = {
              ...subField,
              name: `${field.relationship_name}.${subField.name}`,
              label: `${field.relationship_name}.${subField.label}`,
              parent_field_type: field.field_type,
            };
            fieldList.push(subFieldDef);
            filteredFieldList.push(subFieldDef);
          }
        });
        if (
          field.field_type === "reference" &&
          field.relationship_name === "" &&
          Array.isArray(field.reference_to) &&
          field.reference_to.length > 0
        ) {
          filteredObj[field.reference_to[0]] = filteredFieldList;
        } else if (
          (field.field_type === "multi_reference" ||
            field.field_type === "reference") &&
          field.relationship_name !== ""
        ) {
          filteredObj[field.relationship_name] = filteredFieldList;
          if (field.field_type === "multi_reference") {
            filteredObj.MultiReference.push(field.relationship_name);
          }
        }
      }
    });
    filteredObj.All = fieldList;
    return { fieldList, filteredObj };
  }
  return objSchema;
};

export const getRevvToSourceMapping = fieldMappingList => {
  const fieldMapping = {};
  if (Array.isArray(fieldMappingList)) {
    fieldMappingList.forEach(srcToRevvMap => {
      // update source fields list
      const { revvSubField, revvFieldID, mappingID, mapping } = srcToRevvMap;
      if (revvFieldID in fieldMapping) {
        const { mapping: mappingList, meta } = fieldMapping[revvFieldID];
        const updatedMappingList = [
          ...mappingList,
          { ...mapping, internal_field: revvSubField },
        ];
        const oldInternalFields =
          meta && Array.isArray(meta.internal_fields)
            ? meta.internal_fields
            : [];
        const updatedInternalFields = revvSubField
          ? [...oldInternalFields, revvSubField]
          : oldInternalFields;

        fieldMapping[revvFieldID] = {
          mappingID,
          mapping: updatedMappingList,
          meta: {
            internal_fields: updatedInternalFields,
          },
        };
      } else {
        fieldMapping[revvFieldID] = {
          mapping: [{ ...mapping, internal_field: revvSubField }],
          meta: {
            internal_fields: revvSubField ? [revvSubField] : [],
          },
          mappingID,
        };
      }
    });
  }
  return fieldMapping;
};

export const updateSourceinFieldList = (
  fieldsUsed,
  fieldSrcMap,
  signatories,
) => {
  const fieldList = [];
  let src = "";
  fieldsUsed.forEach(field => {
    const mappedFields = [];
    const fieldMapping = fieldSrcMap.filter(f => field.id === f.id);
    fieldMapping.forEach(f => {
      src = f.crm_source;
      const ds_obj = DATA_SOURCES.find(ds => ds.urlRef === src);
      if (!mappedFields.includes(ds_obj.label)) mappedFields.push(ds_obj.label);
    });
    if (field.type === "TABLE_API" && src !== "") {
      const ds_obj = DATA_SOURCES.find(ds => ds.urlRef === src);
      if (!mappedFields.includes(ds_obj.label)) mappedFields.push(ds_obj.label);
    }
    fieldList.push({
      ...field,
      crm_source: mappedFields.join(", "),
    });
  });

  // Add signer details into the filed list if exists
  if (signatories && signatories.length > 0) {
    signatories.forEach((signer, index) => {
      const mappedSigner = [];
      const ds_obj = DATA_SOURCES.find(ds => ds.urlRef === src);
      if (src !== "" && !mappedSigner.includes(ds_obj.label))
        mappedSigner.push(ds_obj.label);
      if (Array.isArray(signer.tags) && signer.tags.length > 0)
        fieldList.push({
          crm_source: mappedSigner.join(", "),
          id: signer.signer_identity_id,
          meta: { default: `${signer.first_name} ${signer.last_name}` },
          field_name: `signer-${index + 1}`,
          label: `Signer ${index + 1}`,
          type: "SIGNATURE",
          parent_field: "SIGNATURE",
          ...signer,
        });
    });
  }

  return fieldList;
};

export const getSourceFieldsMeta = fieldList =>
  fieldList.map(field => {
    if (
      field.parent_field_type &&
      field.parent_field_type === "multi_reference"
    ) {
      return {
        ...field,
        // name: field.name.split(".")[1],
        field_type: field.parent_field_type,
        relationship_name: field.name.split(".")[0],
      };
    }
    return field;
  });
